module.exports = __webpack_public_path__ + "static/media/button back arrow.35ee03fe.svg";